import { getAlertSeverityColor } from "@hydrologiq/shared/components/AlertSeverityBadge"
import { colourVar } from "@hydrologiq/shared/chakra/colourVar"

export enum SystemNodeVersion {
  V1 = "v1",
  V2 = "v2",
}

/** Height of one property line (an attribute or a Load Precedence row) on a V2 node (px). */
export const NODE_ROW_HEIGHT = 13

export const getNodeDimensions = (
  nodeVersion: SystemNodeVersion,
  controllable: boolean,
  graphsEnabled?: boolean,
  rows = 0,
) => {
  switch (nodeVersion) {
    case SystemNodeVersion.V2:
      return {
        width: 266,
        height:
          112 -
          (!graphsEnabled ? 55 : 0) +
          rows * NODE_ROW_HEIGHT,
      }
    default:
      return {
        width: 175,
        height: controllable ? 75 : 50,
      }
  }
}

export const getNodeColors = (
  nodeVersion: SystemNodeVersion,
  assignmentStatus: "active" | "inactive" | null,
  alertsEnabled?: boolean,
  alertSeverity?: "critical" | "warning" | "info" | null,
) => {
  // These go into the ReactFlow node's raw `style`, not a Chakra prop, so theme
  // tokens are written as their CSS variables to follow the Colour Mode.
  const alertColor = alertsEnabled ? colourVar(getAlertSeverityColor(alertSeverity ?? "ok", true)) : "grey_light"
  switch (nodeVersion) {
    case SystemNodeVersion.V2:
      return {
        background: colourVar("card"),
        text: "primary",
        borderColor: alertColor,
        borderWidth: "2px",
      }
    default:
      switch (assignmentStatus) {
        case "active":
          return {
            backgroundColor: "#39aed2",
            color: "#39aed2",
            borderColor: "#39aed2",
          }
        case "inactive":
        case null:
        default:
          return {
            backgroundColor: "#a9a9a9",
            color: "#a9a9a9",
            borderColor: "#a9a9a9",
          }
      }
  }
}
